export const RISK_CONTENT = [
  {
    label: '尊敬的客户，您好，我是一位金马证券有限公司的持牌代表劉宛欣，我的中央编号是BSU965。'
  },
  {
    label: '在开通账户前，请您仔细阅读金马证券的客户协议书和相关投资产品的风险披露声明。'
  },
  {
    label: '在作出任何投资决定前，您需了解自身的投资经验及目的、风险承受能力、财政状况等，从而审慎考虑该投资产品是否适合您投资。'
  },
  {
    label: '以下为风险披露声明的节录：'
  },
  {
    label: '1. 证券交易的风险'
  },
  {
    label: '证券价格有时可能会非常波动。 证券价格可升可跌，甚至变成毫无价值。 买卖证券未必一定能赚取利润，反而可能会招致损失。'
  },
  {
    label: '2. 买卖创业板股份的风险'
  },
  {
    label: '创业板股份涉及很高的投资风险。 尤其是该等公司可在无需具备盈利业绩及无需预测未来盈利的情况下在创业板上市。 创业板股份可能会非常波动及流通性很低。'
  },
  {
    label: '3. 透过沪港通/深港通买卖证券的特定风险'
  },
  {
    label: '包括'
  },
  {
    label: 'i.每日额度限制，'
  },
  {
    label: 'ii.只能买卖合资格沪深股票'
  },
  {
    label: 'iii.沽出限制'
  },
  {
    label: 'iv.交易日及交易时间差异'
  },
  {
    label: 'v.内地法规、外资持股比例限制及披露责任'
  },
  {
    label: 'vi.股票交收及资金结算安排'
  },
  {
    label: '4. 买卖环球证券的风险'
  },
  {
    label: '环球证券的价值或收益可能较为波动及可能因货币汇率、当地税务惯例、法例或政治事件而遭受负面影响。'
  },
  {
    label: '您有可能较难变卖环球证券。 当地法例也可能影响环球证券的可转让性。而且，有些环球证券交易市场股票的跌幅或升幅超过特定百分比时，有关市场可能会暂停有关股票的交易、对有关股票实施熔断机制或市场波动调节机制等。'
  },
  {
    label: '5. 货币兑换风险'
  },
  {
    label: '货币兑换需承受因汇率波动而产生的风险。倘若您货币兑换的汇率较当初的汇率为差，您可能会因而蒙受本金损失。'
  },
  {
    label: '6. 在香港以外地方收取或持有的客户资产的风险'
  },
  {
    label: '金马证券在香港以外地方收取或持有您的资产，是受到有关海外司法管辖区的适用法律及规例所监管的，请注意，不受投资者赔偿基金保障。 这些香港以外地方的法律及规例与《证券及期货条例》（香港法例第571 章）可能有所不同。'
  },
  {
    label: '7. 电子交易的风险'
  },
  {
    label: '透过电子交易服务进行买卖，潜在风险包括有关系统硬件或软件可能会失灵、网络不稳定、未能预计的网络拥挤等。'
  },
  {
    label: '通过电子交易服务向您提供的市场数据及其他信息，可能是金马证券从第三方或服务供货商获得的。虽然金马证券相信这些数据和信息是可靠的，但金马证券、该等第三方或服务供货商都不会保证这些数据和信息的准确性、完整性和实时性。'
  },
  {
    label: '8. 提供代存邮件或将邮件转交第三方的授权书的风险'
  },
  {
    label: '假如您向金马证券提供授权书，允许第三方代存邮件或将邮件转交予第三方，那么您便须尽速亲身收取所有关于您账户的成交单据及结单，并加以详细阅读，以确保可及时侦察到任何差异或错误。'
  },
  {
    label: '9. 在香港联合交易所有限公司买卖纳斯达克－美国证券交易所证券的风险'
  },
  {
    label: '按照纳斯达克－美国证券交易所试验计划挂牌买卖的证券是为熟悉投资技巧的投资者而设的。您在买卖该项试验计划的证券之前，应先熟悉该项试验计划。'
  },
  {
    label: '您应知悉，按照该项试验计划挂牌买卖的证券并非以香港联合交易所有限公司的主板或创业板作第一或第二上市的证券类别加以监管。'
  },
  {
    label: '以下是泛及开立保证金账户的风险'
  },
  {
    label: '保证金买卖的风险'
  },
  {
    label: '借存放抵押品而为交易取得融资的亏损风险可能极大。蒙受的亏蚀可能会超过您存放于金马证券作为抵押品的现金及任何其他资产。'
  },
  {
    label: '您可能会在短时间内被要求存入额外的保证金款项或缴付利息。假如您未能在指定的时间内支付所需的保证金款项或利息，您的抵押品可能会在未经您的同意下被出售。在市场波动下，金马证券未必能实时联络您或提供足够时间予您存款，而您的持仓将有可能因此被强制平仓。'
  },
  {
    label: '此外，您将要为您的账户内因此而出现的任何短欠金额及需缴付的利息负责。'
  },
  {
    label: '最后您同意客户协议书内的客户款项常设授权、客户证券常设授权或其他的常设授权以上常设授权有效期为十二个月，自本协议书生效之日起计有效。'
  },
  {
    label: ' 您明白金马证券若在客户款项常设授权及客户证券常设授权的有效期届满 14日之前，向您发出书面通知，提醒您有关的常设授权即将届满，而您没有在届满前反对该等常设授权续期，您的客户款项常设授权及客户证券常设授权将按照相同条件及细则自动续期12个月。'
  },
  {
    label: '提供证券抵押品等再质押的授权书的风险'
  },
  {
    label: '证券借贷协议书使用您的证券或证券抵押品、将您的证券抵押品再质押以取得财务通融，或将您的证券抵押品存放为用以履行及清偿其交收责任及债务的抵押品，存在一定风险。'
  },
  {
    label: '假如您的证券或证券抵押品是由金马证券在香港收取或持有，则上述安排仅限于您已就此给予书面同意的情况下方行有效。此外，除非您是专业投资者，您的授权书必须指明有效期，而该段有效期不得超过12个月。若您是专业投资者，则有关限制并不适用。'
  },
  {
    label: '此外，假如金马证券在有关授权的期限届满前最少14日向您发出有关授权将被视为已续期的提示，而您对于有关授权的期限届满前以书面方式将该授权延续不表示反对，则您的授权将按照相同条款及细则自动续期12个月。'
  }
]
